module.exports = __webpack_public_path__ + "static/Apercu-Mono-Pro-Medium-9f640fd841caff9a961141aec4a1d3d3.otf";